<!-- 待售商标资产 -->
<template>
  <div class="development">
    <div class="banner">
      <div class="content">
        <div class="search">
          <input
            type="text"
            v-model="keyword"
            placeholder="请输入关键词"
            @keyup.enter="handleSearch"
          />
          <button @click="handleSearch">
            <img src="../assets/search_icon.png" alt="" />搜索
          </button>
        </div>
        <div class="query">
          <div class="categories">
            <!-- 动态渲染分类 -->
            <div
              class="category-group"
              v-for="(category, index) in categories"
              :key="index"
            >
              <h3>{{ category.title }}</h3>
              <ul :class="{ expanded: category.expanded }">
                <li
                  v-for="(item, i) in category.items"
                  :key="i"
                  :class="{
                    active: activeItems[index] === i,
                    'default-active':
                      i === 0 && !activeItems.hasOwnProperty(index),
                  }"
                  @click="selectItem(index, i)"
                >
                  {{ item }}
                </li>
              </ul>
              <span
                class="more-btn"
                v-if="category.title === '商标类别：'"
                @click="toggleExpand(category)"
              >
                {{ category.expanded ? "收起" : "更多" }}<i>></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="main">
      <div class="content">
        <div class="main_box">
          <div class="header">
            <div class="sort">
              <el-dropdown trigger="click" @command="handleSortChange">
                <span class="el-dropdown-link">
                  {{ currentSort.label
                  }}<img src="../assets/bottomArrow.png" alt="" />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="item in sortOptions"
                    :key="item.id"
                    :command="item"
                  >
                    {{ item.label }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="result">
              <p>搜索结果：</p>
              共有
              <p>{{ total }}</p>
              个结果
            </div>
            <div class="reset" @click="handleReset">
              <i class="el-icon-refresh-right"></i>
              <p>重置搜索</p>
            </div>
          </div>
          <div class="body">
            <div
              class="box"
              v-for="item in tableData"
              :key="item.id"
              @click="getBrand(item)"
            >
              <div class="img">
                <img :src="item.images" alt="" />
                <!-- <img src="../assets/articleImg.png" alt="" /> -->
              </div>

              <ul>
                <li>
                  <span>{{ item.trademark_structure }}</span
                  ><span>{{ item.trademark_category }}</span>
                </li>
                <h1>{{ item.trademark }}</h1>
                <div class="time">
                  发布时间：<span>{{ formatDate(item.create_time) }}</span>
                </div>
                <p>{{ item.price || "面议" }}</p>
              </ul>
            </div>
          </div>
          <div class="paging">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="pageSize"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getParams, getTrademark } from "../api/userApi";
export default {
  data() {
    return {
      page: 1,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      currentSort: {
        label: "按价格排序",
        value: "price",
        type: "desc", // 可以根据需要设置升序或降序，默认是 asc（从低到高）
        id: 2,
      },
      sortOptions: [
        { label: "按发布时间排序", field: "create_time", id: 1 },
        { label: "按价格排序", field: "price", id: 2 },
      ],
      activeItems: {},
      keyword: "",
      tableData: [],
      categories: [
        {
          title: "商标类别：",
          items: ["全部"],
          key: "trademark_category",
          paramKey: "trademark_category",
          expanded: false,
        },
        {
          title: "商标价格：",
          items: ["全部"],
          key: "budget",
          paramKey: "budget",
        },
        {
          title: "商标结构：",
          items: ["全部"],
          key: "trademark_structure",
          paramKey: "trademark_structure",
        },
        {
          title: "商标数字：",
          items: ["全部"],
          key: "word_count",
          paramKey: "word_count",
        },
      ],
    };
  },
  async created() {
    await this.getCategoryData();
    await this.fetchData();
  },
  methods: {
    toggleExpand(category) {
      category.expanded = !category.expanded;
    },
    async getCategoryData() {
      try {
        const response = await getParams();
        if (response.code === 1) {
          this.categories.forEach((category) => {
            const apiData = response.data[category.key];
            if (apiData && apiData.data) {
              // 保存原始数据
              category.originalItems = apiData.data;
              // 显示用选项（保留"全部"）
              category.items = [
                "全部",
                ...apiData.data.map((item) => item.title),
              ];
            }
          });
        }
      } catch (error) {
        console.error("获取分类数据失败:", error);
      }
    },

    async fetchData() {
      try {
        this.loading = true;
        const params = {
          page: this.page,
          limit: this.pageSize,
          sort_field: this.currentSort.field,
          sort_type: this.currentSort.type,
        };
        // 添加关键词搜索
        if (this.keyword) {
          params.keyword = this.keyword;
        }
        // 添加筛选条件
        Object.assign(params, this.getSelectedFilters());
        const response = await getTrademark(params);

        if (response.code === 1) {
          this.tableData = response.data || [];
          this.total = response.count || 0;
        } else {
          this.$message.error(response.message || "获取数据失败");
        }
      } catch (error) {
        console.error("获取数据失败:", error);
        this.$message.error("获取数据失败，请稍后重试");
      } finally {
        this.loading = false;
      }
    },

    getSelectedFilters() {
      const filters = {};
      this.categories.forEach((category, index) => {
        const selectedIndex = this.activeItems[index];
        if (selectedIndex > 0) {
          // 0是"全部"选项
          const selectedItem = category.originalItems[selectedIndex - 1]; // 获取原始数据项
          if (selectedItem) {
            filters[category.paramKey] = selectedItem.id; // 传递ID而不是title
          }
        }
      });
      return filters;
    },

    selectItem(categoryIndex, itemIndex) {
      this.$set(this.activeItems, categoryIndex, itemIndex);
      this.page = 1;
      this.fetchData();
    },

    handleSearch() {
      this.page = 1;
      this.fetchData();
    },

    handleReset() {
      this.keyword = "";
      this.activeItems = {};
      this.currentSort = {
        label: "按发布时间排序",
        value: "create_time",
        type: "desc",
        id: 1,
      };
      this.page = 1;
      this.fetchData();
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.fetchData();
    },

    handleCurrentChange(val) {
      this.page = val;
      this.fetchData();
    },

    handleSortChange(command) {
      const newField = command.field;

      let defaultType = "desc"; // 默认都是 desc
      // 如果点击的是当前已选中的排序字段，则切换排序方向
      // 单独设置某些字段的默认排序方式
      if (newField === "price" || newField === "create_time") {
        defaultType = "asc"; // 假设你想按价格从低到高排
      }

      // 如果是相同字段，就切换 asc / desc
      if (this.currentSort.field === newField) {
        this.currentSort.type =
          this.currentSort.type === "asc" ? "desc" : "asc";
      } else {
        // 不同字段则重置为该字段的默认排序方式
        this.currentSort = {
          label: command.label,
          field: newField,
          type: defaultType,
          id: command.id,
        };
      }

      this.fetchData();
    },

    formatDate(date) {
      if (!date) return "未知";
      return date.split(" ")[0]; // 只显示日期部分
    },

    getBrand(item) {
      this.$router.push({
        path: "/brand",
        query: { id: item.id },
      });
    },
  },
};
</script>

<style scoped lang="less">
.content {
  width: 100%;
  max-width: 87.5rem;
  margin: 0 auto;

  //   position: absolute;
}

.banner {
  //   position: relative;
  background: url(../assets/banner2.png) no-repeat center/cover;
  width: 100%;
  height: 318px;
  .content {
    width: 100%;
    max-width: 87.5rem;
    margin: 0 auto;
    position: relative;

    .query {
      position: absolute;
      width: 100%;
      //   height: 294px;
      background: #ffffff;
      border-radius: 10px 10px 10px 10px;
      left: 0;
      bottom: -342px;
      padding: 37px 35px;
      box-sizing: border-box;
      .categories {
        display: flex;
        flex-direction: column;
        .category-group {
          position: relative;
          //   border-bottom: 1px dashed #d8d8d8;
          background-image: linear-gradient(
            to right,
            #d8d8d8 50%,
            transparent 50%
          );
          background-size: 20px 1px; /* 控制虚线间距：10px 为总长度，50% 透明，50% 实色 */
          background-repeat: repeat-x;
          background-position: bottom; /* 底部边框 */
          display: flex;
          //   padding-left: 20px;
          padding: 20px 0 5px 20px;
          box-sizing: border-box;
          h3 {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #121212;
            width: 8%;
            text-align: left;
          }
          ul {
            width: 92%;
            display: flex;
            flex-wrap: wrap;
            max-height: 30px; // 默认只显示一行
            overflow: hidden;
            transition: max-height 0.3s ease;
            &.expanded {
              max-height: 1000px; // 足够大的值以显示所有内容
            }
            li {
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #121212;
              margin-right: 10px;
              margin-bottom: 4px;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 3px 10px;
              &.active,
              &.default-active {
                background: #175dc2;
                color: #fff;
                padding: 3px 10px;
                box-sizing: border-box;
              }
            }
          }
        }
        .category-group:last-child {
          background-size: 20px 0px;
        }
        .category-group:first-child {
          padding-top: 0;
        }

        .more-btn {
          position: absolute;
          right: 0px;
          top: 4px;
          color: #175dc2;
          cursor: pointer;
          font-size: 14px;
          background: white;
          padding-left: 10px;
          z-index: 1;
          i {
            margin-left: 5px;
            transition: transform 0.3s;
          }
          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }
  .search {
    padding-top: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    input {
      width: 638px;
      height: 50px;
      background: #ffffff;
      border-radius: 9px 0px 0px 9px;
      border: none; /* 移除边框 */
      outline: none;
      padding-left: 25px;
    }
    input::placeholder {
      //   padding-left: 25px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #a9a9a9;
      font-style: normal;
    }
    input:focus {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #121212;
      font-style: normal;
    }
    button {
      cursor: pointer;
      border: none;
      outline: none;
      width: 96px;
      height: 50px;
      background: #c5e1ff;
      border-radius: 0px 9px 9px 0px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #175dc2;
      line-height: 20px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        margin-right: 3px;
      }
    }
  }
}
.main {
  background: #f5f5f5;
  padding-top: 155px;
  padding-bottom: 45px;
  width: 100%;
  .main_box {
    width: 100%;
    // height: 1017px;
    background: #fff;
    border-radius: 10px;
    padding: 15px 40px 35px 40px;
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .sort {
        width: 124px;
        height: 39px;
        background: #ffffff;
        border: 1px solid #d3d3d3;
        display: flex;
        align-items: center;
        justify-content: center;
        ::v-deep .el-dropdown-menu {
          left: 285px !important;
        }
        img {
          margin-left: 10px;
        }
        ::v-deep .el-popper ul {
          left: 299px !important;
        }
      }
      .result {
        display: flex;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: rgba(18, 18, 18, 1);
        p {
          color: #175dc2;
        }
      }
      .reset {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 114px;
        height: 39px;
        background: #ffffff;
        border: 1px solid #d3d3d3;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #121212;
        line-height: 20px;
        cursor: pointer;
        i {
          margin-right: 10px;
          line-height: 20px;
        }
      }
    }
    .body {
      margin-top: 20px;
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      gap: 30px;
      .box {
        margin-right: 17px;
        width: 227px;
        // height: 340px;
        background: #ffffff;
        border-radius: 6px 6px 6px 6px;
        border: 1px solid #dddddd;
        display: flex;
        flex-direction: column;
        .img {
          width: 225px;
          height: 187px;
          img {
            width: 225px;
            height: 187px;
            vertical-align: baseline;
            // width: 225px;
            // height: 187px;
            border-radius: 6px 6px 0px 0px;
          }
        }

        ul {
          // border: 1px solid #dddddd;
          // border-top: 0;
          border-radius: 0px 0px 6px 6px;
          display: flex;
          flex-direction: column;
          padding: 10px 15px 15px 15px;
          li {
            display: flex;
            justify-content: space-between;
            span {
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 18px;
              color: rgba(18, 18, 18, 0.3);
              text-align: left;
            }
          }
          h1 {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 20px;
            color: #0c1223;
            margin-top: 10px;
            text-align: left;
            white-space: nowrap; /* 新增 */
            overflow: hidden; /* 新增 */
            text-overflow: ellipsis; /* 新增 */
            width: 100%;
          }
          .time {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 18px;
            color: rgba(18, 18, 18, 0.5);
            margin-top: 5px;
            text-align: left;
          }
          p {
            margin-top: 10px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 600;
            font-size: 18px;
            color: #175dc2;
            text-align: left;
            white-space: nowrap; /* 新增 */
            overflow: hidden; /* 新增 */
            text-overflow: ellipsis; /* 新增 */
            width: 100%;
          }
        }
      }
    }
    .paging {
      margin-top: 35px;
      display: flex;
      justify-content: flex-end;
      padding-right: 45px;
    }
  }
}
</style>
